
<div class="card m-b-15 br-7 base-shadow-list b-0" [ngClass]="{'survey-question-background': isSurveyQuestion}" *ngIf="!isEdit; else buildFormTemplate">
    <div class="row">
        <div class="col-10">
            <div [ngSwitch]="question.answerType" class="p-l-20 p-b-5">
                <div *ngSwitchCase="questionType.Text">
                    <app-question-text [question]="question">
                    </app-question-text>
                </div>
                <div *ngSwitchCase="questionType.Number">
                    <app-question-text [question]="question">
                    </app-question-text>
                </div>
                <div *ngSwitchCase="questionType.Checkbox">
                    <app-question-checkbox-radio [question]="question">
                    </app-question-checkbox-radio>
                </div>
                <div *ngSwitchCase="questionType.Radiobutton">
                    <app-question-checkbox-radio [question]="question">
                    </app-question-checkbox-radio>
                </div>
                <div *ngSwitchCase="questionType.SatisfactionRate">
                    <app-question-checkbox-radio [question]="question">
                    </app-question-checkbox-radio>
                </div>
                <div *ngSwitchCase="questionType.Rating">
                    <app-question-checkbox-radio [question]="question">
                    </app-question-checkbox-radio>
                </div>
                <div *ngSwitchCase="questionType.MatrixRadiobutton">
                    <app-question-matrix [question]="question"></app-question-matrix>
                </div>
                <div *ngSwitchCase="questionType.MatrixCheckbox">
                    <app-question-matrix [question]="question"></app-question-matrix>
                </div>
                <div *ngSwitchDefault>
                    <app-question-text [question]="question"></app-question-text>
                </div>
            </div>
        </div>
        <div class="col-2">
            <div class="col-12 clearfix m-t-10" *ngIf="!isSurveyQuestion">
                <i class="float-right btn btn-sm ti-close" id="delete_question" (click)="deleteQuestion(question.id)"></i>
                <i class="float-right btn btn-sm ti-files" id="clone_question" (click)="cloneQuestion(question)"></i>
                <i class="float-right btn btn-sm ti-pencil" id= "edit_question" (click)="getQuestionForEdit(question.id)"></i>
            </div>
            <div class="col-12 clearfix m-t-10" *ngIf="isSurveyQuestion">
                    <i class="float-right btn btn-sm ti-close" (click)="removeQuestionFromSurvey(question.questionId)"></i>
                    <i class="float-right m-r-20" 
                    [ngClass]="(isMandatoryQuestion)?'mandatory-question':'regular-question'" 
                    (click)="changeQuestionMandatory(question.questionId)"></i>
            </div>
        </div>
    </div>
</div>
<ng-template #buildFormTemplate>
    <div class="m-b-15 card base-shadow-list b-0">
        <div class="card-body">
            <app-question-forms-builder 
            (onCancelForm)="hideForm()"
            (onSaveAddEditForm)="closeOnSave($event)"
            [question]="question"></app-question-forms-builder>
        </div>
    </div>
</ng-template>